export class RecalcInfo {
    Id_RecalcName: number;
    RecalcName: string;
    Description: string;
    Volume: number;
    BulkVolume: number;
    PieceWeight: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recalcInfo.model.ts